import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { CognitoIdentityServiceProvider } from 'aws-sdk';
import React, { useState } from 'react';
import DetailField from '../Detail/DetailField';

interface Props {
    group?: CognitoIdentityServiceProvider.GroupType;
    onSave: (group: CognitoIdentityServiceProvider.GroupType) => void;
    onClose: () => void;
}

export default function CreateGroupDialog(props: Props) {

    const [group, setGroup] = useState<CognitoIdentityServiceProvider.GroupType>();

    return (
        <React.Fragment>
            <Dialog open={true} fullWidth={true} onClose={props.onClose} aria-labelledby="form-dialog-title" maxWidth={"md"} >
                <DialogTitle>Create Group</DialogTitle>
                <DialogContent>

                    <DetailField
                        type="text"
                        required
                        labelWidth={3}
                        label="Name:"
                        value={group?.GroupName}
                        onChange={val => setGroup({ ...group, GroupName: val || '' })}
                    />

                    <DetailField
                        type="text"
                        labelWidth={3}
                        label="Description:"
                        value={group?.Description}
                        onChange={val => setGroup({ ...group, Description: val || '' })}
                    />

                    {/*<DetailField
                        type="text"
                        labelWidth={3}
                        label="Precedence:"
                        value={group?.Precedence?.toString()}
                        onChange={val => setGroup({ ...group, Precedence: val !== undefined ? parseInt(val, 10) : undefined })}
                    />*/}
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose} color="primary">
                        Cancel
                    </Button>
                    <Button disabled={!group?.GroupName} onClick={() => {
                        if (group) { props.onSave(group); }
                        props.onClose();
                    }} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}